{
  "removeButtonLabel": "Kaldır",
  "removeDescription": "Etiketi kaldırmak için Sil tuşuna basın."
}
